import request from '@/utils/request'
// 上传图片
export function upFile(data) {
  return request({
    url: '/common/webUploadFile',
    method: 'post',
    data: data
  })
}
// 字典
export function dictData(val) {
  let _params = {
    dictType: val,
    pageSize: 100,
    pageNum: 1
  }
  return request({
    url: '/web/common/dict/list',
    method: 'get',
    params: _params
  })
}